export default ({ POST, GET, UPLOAD }) => {
  return {
    // 获取文章
    GetArticles: (...arg) => POST('/get_articles', ...arg),

    // 获取文章
    GetArticle: (...arg) => POST('/get_article', ...arg),

    // 保存文章
    SaveArticle: (...arg) => POST('/admin/save_article', ...arg),

    // 删除文章
    DelArticle: (...arg) => POST('/admin/del_article', ...arg),

    // 点赞文章
    LikeArticle: (...arg) => POST('/like_article', ...arg),

    // 浏览文章
    ViewArticle: (...arg) => POST('/view_article', ...arg)
  }
}
